import styled from 'styled-components';

export default styled.div`
  .order-detail-container {
    height: calc(100vh - 56px - 80px);
    display: flex;
    gap: 24px;
    padding-top: 20px;
    .repertoire-container-content-left {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 12px;
      .order-detail-item {
        display: flex;
        gap: 12px;
        align-items: center;
        .order-detail-item-label {
          font-weight: 400;
          font-size: 14px;
          line-height: 100%;
          letter-spacing: 0%;
          color: #666666;
        }
        .order-detail-item-value {
          font-weight: 500;
          font-size: 14px;
          line-height: 100%;
          letter-spacing: 0%;
          color: #111111;
        }
      }
    }
    .repertoire-container-content-right {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 12px;
      .right-content {
        width: 400px;
        background-color: #2c9ae9;
        border-radius: 8px;
        padding: 16px;
        .right-content-item {
          display: flex;
          gap: 12px;
          align-items: center;
          label {
            width: 57px;
            font-weight: 400;
            font-size: 14px;
            line-height: 100%;
            letter-spacing: 0%;
            color: #c0e2fb;
          }
          .right-content-value {
            font-weight: 500;
            font-size: 14px;
            line-height: 100%;
            letter-spacing: 0%;
            color: #ffffff;
          }
        }
        .right-ticket-name {
          font-weight: 500;
          font-size: 20px;
          line-height: 100%;
          letter-spacing: 0%;
          color: #ffffff;
          margin-bottom: 6px;
        }
        .ticket-info-wrap {
          display: flex;
          align-items: center;
        }
        .right-ticket-info-left {
          display: flex;
          gap: 6px;
          flex-direction: column;
          .right-ticket-info-item {
            display: flex;
            gap: 12px;
            align-items: center;
            label {
              width: 57px;
              font-weight: 400;
              font-size: 14px;
              line-height: 100%;
              letter-spacing: 0%;
              color: #c0e2fb;
            }
            .right-ticket-info-item-value {
              font-weight: 500;
              font-size: 14px;
              line-height: 100%;
              letter-spacing: 0%;
              color: #ffffff;
            }
          }
        }
        .right-ticket-info-right {
          flex: 1;
          display: flex;
          flex-direction: column;
          .actual-payment-label {
            font-weight: 400;
            font-size: 14px;
            line-height: 100%;
            letter-spacing: 0%;
            color: #c0e2fb;
            text-align: right;
          }
          .actual-payment-value {
            font-weight: 500;
            font-size: 24px;
            height: 34px;
            line-height: 34px;
            letter-spacing: 0%;
            color: #ffffff;
            text-align: right;
          }
          .discount-amount-wrap {
            display: flex;
            gap: 12px;
            align-items: center;
            justify-content: flex-end;
            .discount-amount-label {
              font-weight: 400;
              font-size: 14px;
              line-height: 100%;
              letter-spacing: 0%;
              color: #c0e2fb;
            }
            .discount-amount-value {
              font-weight: 500;
              font-size: 14px;
              line-height: 100%;
              letter-spacing: 0%;
              color: #ffffff;
            }
          }
        }
        .set-num-wrap {
          display: flex;
          gap: 12px;
          align-items: center;
          .set-num-label {
            font-weight: 400;
            font-size: 14px;
            line-height: 100%;
            letter-spacing: 0%;
            color: #c0e2fb;
          }
          .set-num-value {
            font-weight: 500;
            font-size: 14px;
            line-height: 100%;
            letter-spacing: 0%;
            color: #ffffff;
          }
        }
      }
    }
  }
`;
